import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import Loader from "../../Components/Loader/Loader";
import NotFound from "../NotFound/NotFound";
import { teamUrl } from "../../Utils/Constants";
import { errorMessage, getSportHub } from "../../Utils/api";
import "./Catalogue.css";

/**
 * `/sports/{sport-slug}` — teams grouped by conference.
 *
 * New: the product had no sport or team pages at all, only two funnel-scoped
 * grids. These are the most linkable surfaces on a site like this ("Alabama
 * football NIL"), and 3 sport + 859 team pages come almost free from data that
 * already exists.
 */
export default function SportPage() {
  const { sportSlug } = useParams();
  const [hub, setHub] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getSportHub(sportSlug)
      .then((data) => {
        if (!cancelled) setHub(data);
      })
      .catch((error) => {
        if (cancelled) return;
        if (error?.response?.status === 404) setNotFound(true);
        else toast.error(errorMessage(error, "Could not load this sport"));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [sportSlug]);

  useEffect(() => {
    if (hub?.sport) document.title = `${hub.sport.sport_name} · NIL-Collab`;
  }, [hub]);

  if (notFound) return <NotFound />;

  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}

      {hub ? (
        <div className="cat-page">
          <nav className="cat-crumbs">
            <Link to="/sports">Sports</Link>
            <span>/</span>
            <span>{hub.sport.sport_name}</span>
          </nav>

          <h1 className="cat-title">{hub.sport.sport_name}</h1>
          <p className="cat-sub">
            {hub.sport.team_count} teams across {hub.conferences.length}{" "}
            conferences
          </p>

          {hub.conferences.map((group) => (
            <section key={group.conference} className="cat-conf">
              <h2>{group.conference}</h2>
              <div className="cat-team-grid">
                {group.teams.map((team) => (
                  <Link
                    key={team.team_id}
                    to={teamUrl(hub.sport.slug, team.slug)}
                    className="cat-team-card"
                  >
                    {team.team_logo_url ? (
                      <img src={team.team_logo_url} alt="" aria-hidden="true" />
                    ) : (
                      <div className="cat-team-logo-fallback" aria-hidden="true">
                        {(team.team_name || "?").charAt(0)}
                      </div>
                    )}
                    <span className="cat-team-name">
                      {team.team_name}
                      <span className="cat-team-count">
                        {team.roster_count} athletes
                      </span>
                    </span>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      ) : null}

      <Footer />
    </div>
  );
}
